"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isColorName = isColorName;
exports.isHexColor = isHexColor;
exports.isRgbColor = isRgbColor;
exports.isRgbaColor = isRgbaColor;
exports.isHslColor = isHslColor;
exports.isHslaColor = isHslaColor;
exports.isHwbColor = isHwbColor;
exports.cssColorFormat = cssColorFormat;
exports.isCssColor = isCssColor;

var _cssColorNames = _interopRequireDefault(require("css-color-names"));

var _valueChecks = require("./value-checks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var cssColorNames = Object.keys(_cssColorNames.default);

function isValidRgbValues() {
  for (var _i = 0; _i < arguments.length; _i++) {
    var value = _i < 0 || arguments.length <= _i ? undefined : arguments[_i];

    if (!(0, _valueChecks.isValidRgbVal)(value)) {
      return false;
    }
  }

  return true;
}

function isColorName(value) {
  for (var _i2 = 0; _i2 < cssColorNames.length; _i2++) {
    var name = cssColorNames[_i2];

    if (name === value) {
      return true;
    }
  }

  return false;
}

function isHexColor(value) {
  return value.match(/^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i) !== null;
}

function isRgbColor(value) {
  var rgbMatches = value.match(/^rgb\s*\(\s*(\d+|\d*\.\d+)\s*,\s*(\d+|\d*\.\d+)\s*,\s*(\d+|\d*\.\d+)\s*\)$/);

  if (rgbMatches && rgbMatches.length >= 4) {
    var _rgbMatches = _slicedToArray(rgbMatches, 4),
        rgb = _rgbMatches[0],
        r = _rgbMatches[1],
        g = _rgbMatches[2],
        b = _rgbMatches[3];

    if (isValidRgbValues(r, g, b)) {
      return true;
    }
  }

  return false;
}

function isRgbaColor(value) {
  var rgbaMatches = value.match(/^rgba\s*\(\s*(\d+|\d*\.\d+)\s*,\s*(\d+|\d*\.\d+)\s*,\s*(\d+|\d*\.\d+)\s*,\s*(\d+|\d*\.\d+)\s*\)$/);

  if (rgbaMatches && rgbaMatches.length >= 5) {
    var _rgbaMatches = _slicedToArray(rgbaMatches, 5),
        rgb = _rgbaMatches[0],
        r = _rgbaMatches[1],
        g = _rgbaMatches[2],
        b = _rgbaMatches[3],
        a = _rgbaMatches[4];

    if (isValidRgbValues(r, g, b) && (0, _valueChecks.isValidAlphaValue)(a)) {
      return true;
    }
  }

  return false;
}

function isHslColor(value) {
  var hslMatches = value.match(/^hsl\s*\(\s*(\d+|\d*\.\d+)\s*,\s*(\d+|\d*\.\d+)%\s*,\s*(\d+|\d*\.\d+)%\s*\)$/);

  if (hslMatches && hslMatches.length >= 4) {
    var _hslMatches = _slicedToArray(hslMatches, 4),
        hsl = _hslMatches[0],
        h = _hslMatches[1],
        s = _hslMatches[2],
        l = _hslMatches[3];

    if ((0, _valueChecks.isValidHue)(h) && (0, _valueChecks.isValidPercentageString)(s) && (0, _valueChecks.isValidPercentageString)(l)) {
      return true;
    }
  }

  return false;
}

function isHslaColor(value) {
  var hslaMatches = value.match(/^hsla\s*\(\s*(\d+|\d*\.\d+)\s*,\s*(\d+|\d*\.\d+)%\s*,\s*(\d+|\d*\.\d+)%\s*,\s*(\d+|\d*\.\d+)\s*\)$/);

  if (hslaMatches && hslaMatches.length >= 5) {
    var _hslaMatches = _slicedToArray(hslaMatches, 5),
        hsl = _hslaMatches[0],
        h = _hslaMatches[1],
        s = _hslaMatches[2],
        l = _hslaMatches[3],
        a = _hslaMatches[4];

    if ((0, _valueChecks.isValidHue)(h) && (0, _valueChecks.isValidPercentageString)(s) && (0, _valueChecks.isValidPercentageString)(l) && (0, _valueChecks.isValidAlphaValue)(a)) {
      return true;
    }
  }

  return false;
}

function isHwbColor(value) {
  var hwbMatches = value.match(/^hwb\s*\(\s*(\d+|\d*\.\d+)\s*,\s*(\d+|\d*\.\d+)%\s*,\s*(\d+|\d*\.\d+)%\s*\)$/);

  if (hwbMatches && hwbMatches.length >= 4) {
    var _hwbMatches = _slicedToArray(hwbMatches, 4),
        hwb = _hwbMatches[0],
        h = _hwbMatches[1],
        w = _hwbMatches[2],
        b = _hwbMatches[3];

    try {
      var whiteness = Number.parseFloat(w);
      var blackness = Number.parseFloat(b);

      if ((0, _valueChecks.isValidHue)(h) && (0, _valueChecks.isValidPercentage)(whiteness + blackness) && (0, _valueChecks.isValidPercentage)(whiteness) && (0, _valueChecks.isValidPercentage)(blackness)) {
        return true;
      }
    } catch (err) {
      return false;
    }
  }

  return false;
}

function cssColorFormat(value) {
  var colorTypeCheckers = [[isHexColor, 'hex'], [isHslaColor, 'hsla'], [isHslColor, 'hsl'], [isRgbColor, 'rgb'], [isRgbaColor, 'rgba'], [isColorName, 'named'], [isHwbColor, 'hwb']];

  for (var _i3 = 0; _i3 < colorTypeCheckers.length; _i3++) {
    var _colorTypeCheckers$_i = _slicedToArray(colorTypeCheckers[_i3], 2),
        colorCheckingFunction = _colorTypeCheckers$_i[0],
        typeName = _colorTypeCheckers$_i[1];

    if (colorCheckingFunction(value)) {
      return typeName;
    }
  }

  return null;
}

function isCssColor(value) {
  if (cssColorFormat(value)) {
    return true;
  } else {
    return false;
  }
}